import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Link, Breadcrumbs, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom'

import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    wrap: {
        width: '100%',
        padding: '5px',
        marginTop: '20px',
        marginBottom: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    childHeader: {
        marginTop: '10px',
        fontSize: '1.4rem',
        fontWeight: 'bold',
        color: '#fff',
        textAlign: 'center',
        border: '2px solid #000',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        borderBottom: 'none',
        backgroundColor: '#3F51B5'
    },
    childFooter: {
        paddingTop: '10px',
        padding: '5px',
        border: '2px solid #000',
        borderTop: 'none',
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px',
        backgroundColor: '#fff',
        fontSize: '1rem',
    },
    anchor: {
        fontSize: '18px',
        backgroundColor: ''
    }
}));

// 説明
function PageExplanation(props){
    const classes = useStyles();

    const igonFlag = props.igonFlag;

    const handleScroll = () => {
        document.getElementById('flow_title').scrollIntoView(true);
    }

    return(
        <div id="page_top" className={classes.wrap}>
            <Breadcrumbs aria-label="breadcrumb">
                {
                    (() => {
                        if(igonFlag){
                            return(
                                <Link color="inherit" href="/#/authorwill">
                                    <Typography color="textPrimary">自筆証書遺言を作成する</Typography>
                                </Link>
                            );
                        }else{
                            return(
                                <Link color="inherit" href="/#/author">
                                    <Typography color="textPrimary">財産目録を作成する</Typography>
                                </Link>
                            );
                        }
                    })()
                }
                <Typography color="textPrimary">{props.pageName}</Typography>
            </Breadcrumbs>
            <div className={classes.childHeader}>
                {props.pageName}を順にご入力ください。
            </div>
            <div className={classes.childFooter}>
                作成前に、預金通帳、固定資産税通知書、不動産登記簿謄本、国債、株式、社債などに関する金融機関発行の証明書、保険証書など財産にまつわる書類を事前にご準備いただき、お手元に揃えた上で作成いただくと、スムーズです。
                <br/><br/>
                <Link className={classes.anchor} onClick={handleScroll}>入力に関する説明を見る</Link>
            </div>
        </div>
    );
}

export default PageExplanation
